var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 24,
    viewBox: "0 0 38 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2882_262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.934448 4C0.934448 1.79086 2.72531 0 4.93445 0H33.9344C36.1436 0 37.9344 1.79086 37.9344 4V20C37.9344 22.2091 36.1436 24 33.9344 24H4.93445C2.72531 24 0.934448 22.2091 0.934448 20V4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1472 0.0491803H1.72168C1.31408 0.0491803 0.98365 0.379462 0.98365 0.786885V23.2131C0.98365 23.6205 1.31408 23.9508 1.72168 23.9508H37.1472C37.5548 23.9508 37.8852 23.6205 37.8852 23.2131V0.786885C37.8852 0.379462 37.5548 0.0491803 37.1472 0.0491803Z",
    fill: "#0165B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.72168 0.0983607C1.34125 0.0983607 1.03285 0.406623 1.03285 0.786885V23.2131C1.03285 23.5934 1.34125 23.9016 1.72168 23.9016H37.1472C37.5276 23.9016 37.836 23.5934 37.836 23.2131V0.786885C37.836 0.406623 37.5276 0.0983607 37.1472 0.0983607H1.72168ZM0.934448 0.786885C0.934448 0.3523 1.2869 0 1.72168 0H37.1472C37.582 0 37.9344 0.3523 37.9344 0.786885V23.2131C37.9344 23.6477 37.582 24 37.1472 24H1.72168C1.2869 24 0.934448 23.6477 0.934448 23.2131V0.786885Z",
    fill: "#495057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5409 17.166C30.5409 19.0895 28.9852 20.6557 27.0748 20.6557H8.21636V6.83404C8.21636 4.91054 9.77198 3.34426 11.6825 3.34426H30.5409V17.166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6693 4.51214C24.3049 4.51214 23.1856 5.62503 23.1856 7.01268V9.6094H26.6929C26.7746 9.6094 26.8701 9.6094 26.9386 9.62315C27.7297 9.66437 28.3166 10.0765 28.3166 10.791C28.3166 11.3543 27.9208 11.8352 27.1842 11.9313V11.9588C27.9891 12.0138 28.6032 12.4672 28.6032 13.1679C28.6032 13.9235 27.9208 14.4182 27.0202 14.4182H23.1722V19.5016H26.8158C28.1802 19.5016 29.2991 18.3887 29.2991 17.001V4.51214H25.6693Z",
    fill: "url(#paint0_linear_2882_262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4003 13.6213H25.8333C25.8536 13.6213 25.8876 13.6178 25.922 13.6144C25.9561 13.6109 25.9901 13.6075 26.0104 13.6075C26.2834 13.5526 26.5154 13.3052 26.5154 12.9618C26.5154 12.632 26.2834 12.3847 26.0104 12.316C25.9697 12.3023 25.8876 12.3023 25.8333 12.3023H24.4003V13.6213Z",
    fill: "url(#paint1_linear_2882_262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8333 10.3651C26.1061 10.4063 26.3381 10.6261 26.3381 10.9559C26.3381 11.2856 26.1061 11.5054 25.8333 11.5467C25.8195 11.5604 25.7378 11.5604 25.6967 11.5604H24.4003V10.3513H25.6967C25.7193 10.3513 25.75 10.3555 25.7778 10.3592C25.8004 10.3623 25.8209 10.3651 25.8333 10.3651Z",
    fill: "url(#paint2_linear_2882_262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9418 4.51214C10.5771 4.51214 9.45815 5.62503 9.45815 7.01268V13.1816C10.1541 13.5251 10.8773 13.7449 11.6005 13.7449C12.4601 13.7449 12.9242 13.2228 12.9242 12.5084V9.59567H15.0529V12.4946C15.0529 13.6213 14.3569 14.5418 11.9962 14.5418C10.5634 14.5418 9.44449 14.2258 9.44449 14.2258V19.4879H13.0878C14.4526 19.4879 15.5715 18.375 15.5715 16.9873V4.51214H11.9418Z",
    fill: "url(#paint3_linear_2882_262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8055 4.51214C17.441 4.51214 16.322 5.62503 16.322 7.01268V10.2826C16.9497 9.74679 18.0413 9.40332 19.8016 9.48574C20.7432 9.52696 21.753 9.78803 21.753 9.78803V10.8459C21.2482 10.5849 20.6476 10.3513 19.87 10.2964C18.5325 10.2002 17.7276 10.8597 17.7276 12.0138C17.7276 13.1816 18.5325 13.8411 19.87 13.7312C20.6476 13.6762 21.2482 13.4289 21.753 13.1816V14.2395C21.753 14.2395 20.7568 14.5006 19.8016 14.5418C18.0413 14.6242 16.9497 14.2807 16.322 13.7449V19.5155H19.9654C21.3299 19.5155 22.449 18.4026 22.449 17.0149V4.51214H18.8055Z",
    fill: "url(#paint4_linear_2882_262)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.93445 0.5H33.9344C35.8674 0.5 37.4344 2.067 37.4344 4V20C37.4344 21.933 35.8674 23.5 33.9344 23.5H4.93445C3.00145 23.5 1.43445 21.933 1.43445 20V4L1.43933 3.82031C1.53287 1.97083 3.06172 0.5 4.93445 0.5Z",
    stroke: "#6C757D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2882_262",
    x1: 1.00219,
    y1: 10.3144,
    x2: 38.0343,
    y2: 10.3144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2882_262",
    x1: -20.3525,
    y1: -24.5308,
    x2: 86.9189,
    y2: -24.5308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2882_262",
    x1: -22.3005,
    y1: 11.9656,
    x2: 94.7873,
    y2: 11.9656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2882_262",
    x1: 0.999578,
    y1: 12.0014,
    x2: 38.6037,
    y2: 12.0014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8261,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2882_262",
    x1: 16.2868,
    y1: 12.0009,
    x2: 22.3344,
    y2: 12.0009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1735,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5731,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8585,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2882_262"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.934448 4C0.934448 1.79086 2.72531 0 4.93445 0H33.9344C36.1436 0 37.9344 1.79086 37.9344 4V20C37.9344 22.2091 36.1436 24 33.9344 24H4.93445C2.72531 24 0.934448 22.2091 0.934448 20V4Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.feced4e33bad4b70c2ecb1d31a5fbb88.svg";
export { ForwardRef as ReactComponent };